<template>
    <div class="appointment-clear-modal">
        <b-modal :id="modalId"
                 @hidden="clearSelected">
            <template v-slot:modal-header>
                <h5>{{ $i18n.gt('HEADER_APPOINTMENT_CLEAR') }}</h5>
            </template>
            <b-tabs v-model="selectedTab">
                <b-tab :title="$i18n.gt('TAB_LABEL_SPECIFIC_DATES')">
                    <div class="col py-3">
                        <b-calendar v-model="selectedDate"
                                    :hide-header="true"
                                    :locale="locale"/>
                    </div>
                </b-tab>
                <b-tab :title="$i18n.gt('TAB_LABEL_REPEATED_PATTERN')">
                    <div class="col">
                        <b-form-checkbox-group class="py-3"
                                               :options="weekDays"
                                               v-model="selectedWeekDays"
                                               buttons/>
                        <div class="week-count pb-3">
                            <div>{{ $i18n.gt('FIELD_APPOINTMENT_CLONE_FOR') }}</div>
                            <b-form-input type="number" step="1" max="78" min="0" v-model="weekCount"/>
                            <div>{{ $i18n.gt('FIELD_APPOINTMENT_CLONE_WEEKS') }}</div>
                        </div>
                    </div>
                </b-tab>
                <b-form-radio-group :options="timeRadio"
                                    v-model="selectedTimeRadio"
                                    @input="clearTimes"/>
                <template v-if="selectedTimeRadio">
                    {{ $i18n.gt('FIELD_APPOINTMENT_CLEAR_RANGE_START') }}:
                    <b-form-timepicker minutes-step="5" locale="en" v-model="rangeStart"/>
                    {{ $i18n.gt('FIELD_APPOINTMENT_CLEAR_RANGE_END') }}:
                    <b-form-timepicker minutes-step="5" locale="en" v-model="rangeEnd"/>
                </template>
            </b-tabs>

            <template v-slot:modal-footer>
                <b-btn @click="hideModal">{{ $i18n.gt('LABEL_CANCEL') }}</b-btn>
                <b-btn @click="validateClear">{{ $i18n.gt('LABEL_APPOINTMENT_CLEAR') }}</b-btn>
            </template>
        </b-modal>
    </div>
</template>

<script>
import Vue from 'vue'
import moment from 'moment'
import * as _ from 'lodash'

export default Vue.extend({
    name: 'AppointmentClearModal',
    props: {
      reloadCalendar: Function,
      reloadSelected: Function,
    },
    data () {
        return {
            selectedTab: 0,
            weekDays: [
                { text: 'S', value: 0 },
                { text: 'M', value: 1 },
                { text: 'T', value: 2 },
                { text: 'W', value: 3 },
                { text: 'T', value: 4 },
                { text: 'F', value: 5 },
                { text: 'S', value: 6 },
            ],
            selectedWeekDays: [],
            timeRadio: [
                { text: this.$i18n.gt('LABEL_TIME_RADIO_ENTIRE_DAY'), value: 0 },
                { text: this.$i18n.gt('LABEL_TIME_RADIO_TIME_RANGE'), value: 1 }
            ],
            selectedTimeRadio: 0,
            weekCount: null,
            selectedDate: this.inputDate ? this.inputDate : null,
            rangeStart: null,
            rangeEnd: null,
            appointmentsToClear: [],
        }
    },
    computed: {
        modalId() {
            return 'appointmentClearModal'
        },
        userId() {
            return this.$store.state.currentUser.id
        },
        locale() {
           return this.$store.state.language
        },
    },
    methods: {
        showModal() {
            this.$bvModal.show(this.modalId)
        },
        hideModal() {
            this.$bvModal.hide(this.modalId)
        },
        clearSelected () {
            this.selectedTab = 0
            this.selectedWeekDays = []
            this.weekCount = 0
            this.selectedTimeRadio = 0
            this.selectedDate = null
            this.rangeStart = null
            this.rangeEnd = null
        },
        clearTimes(checked) {
          if (checked === 0) {
              this.rangeStart = null
              this.rangeEnd = null
          }
        },
        validateClear() {
            let invalid = false;
            if (this.selectedTab === 0) {
                if (this.selectedDate === null) {
                    invalid = true;
                }
            } else {
                if (this.selectedWeekDays < 1 || this.weekCount == null) {
                    invalid = true;
                }
            }
            if (this.selectedTimeRadio === 1 && (!this.rangeStart || !this.rangeEnd)) {
                invalid = true;
            }

            if (invalid) {
                this.$toasted.error('Please fill out all fields to clear appointment times', { duration: 5000 })
            } else this.clear()
        },
        async clear() {
            this.hideModal();
            this.appointmentsToClear = await this.$api.getAppointmentsToClear(
                this.userId,
                this.selectedDate,
                this.selectedWeekDays,
                this.weekCount,
                this.selectedTimeRadio ? this.rangeStart : '00:00:00',
                this.selectedTimeRadio ? this.rangeEnd : '23:59:59',
                moment(Date.now()).format('YYYY-MM-DD')
            )
            if (this.appointmentsToClear) {
                let message
                if (this.appointmentsToClear.length === 1) {
                    message = this.$i18n.gt('WARNING_APPOINTMENT_CLEAR_SINGLE')
                } else message = this.$i18n.gt('WARNING_APPOINTMENT_CLEAR_PLURAL').replace('{appointment_count}', this.appointmentsToClear.length.toString())
                this.$bvModal.msgBoxConfirm(message)
                    .then(async (value) => {
                        if (value) {
                            await _.each(this.appointmentsToClear, async (appointment) => {
                                if (appointment['emr_id']) {
                                    await this.$api.emrDelete(this, 'appointment', appointment['emr_id'], this.$user.practitionerPracticeId())
                                }
                            })
                            await this.$api.clearAppointments(this.appointmentsToClear)
                            this.reloadCalendar()
                            this.reloadSelected()
                        }
                    })
            }
        }
    },
    watch: {
        '$store.state.language' : {
            handler: function (newVal, oldVal) {
                this.timeRadio[0].text = this.$i18n.gt('LABEL_TIME_RADIO_ENTIRE_DAY')
                this.timeRadio[1].text = this.$i18n.gt('LABEL_TIME_RADIO_TIME_RANGE')
            }
        },
    }
})
</script>

<style lang="scss">
#appointmentClearModal {
    .b-calendar .b-calendar-nav .btn {
        color: var(--gray);
        &:hover {
            color: var(--white);
        }
    }
    .btn-outline-primary {
        color: var(--blue);
        &:hover {
            color: var(--white);
        }
    }
    .col {
        justify-content: center;
        display: grid;
        text-align: center;
    }
    .btn-group .btn {
        height: 3em;
        padding: 1em;
    }
    .week-count {
        display: inline;
        div, input {
            width: 5em;
            display: inline-block;
        }
    }
    .b-form-timepicker > .btn {
        padding: 0 .5em;
        color: black;
    }

    .dropdown-menu .btn {
        color: black;
    }

    .b-form-timepicker b-icon .btn:hover {
        color: black
    }
}
</style>
